<div class="agency-section"></div>
<div class="table-wrapper">
  <div class="table-header gap-4">
    <div class="align-items-center flex">
      <div>
        <button
          pButton
          pRipple
          type="button"
          [disabled]="loading"
          class="p-button-rounded p-button-text reload-btn"
          (click)="getFormDataList()"
        ></button>
      </div>
      <h2>Form Data Management</h2>
      <div class="user-label">
        <img
          alt="question.svg"
          class="form-data-icon"
          src="../../assets/images/form-data-icon.svg"
        />
        <span>{{ totalFormData }}</span>
      </div>
    </div>

    <div class="align-items-center flex">
      <div class="p-inputgroup table-search-wrapper">
        <span class="p-inputgroup-addon"
          ><img alt="search.svg" src="../../assets/images/search.svg"
        /></span>
        <input
          (keyup)="searchFormData()"
          [(ngModel)]="searchInput"
          class="table-search-field"
          placeholder="Search question by ID or Question text"
          type="text"
        />
      </div>
      <p-button
        (click)="onAddFormDataClick()"
        label="Add Question"
        styleClass="button-sm add-icon"
      ></p-button>
    </div>
  </div>
  <p-table
    #dt
    [rowHover]="true"
    [rowsPerPageOptions]="[10, 20, 30]"
    [rows]="10"
    [showCurrentPageReport]="true"
    [value]="formDataList"
    dataKey="id"
  >
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th id="question-id" [width]="'130px'">Question ID</th>
        <th id="company-name" [width]="'130px'">
          <div class="flex align-items-center gap-2">
            <span>Company</span>
            <div class="filterClass" *ngIf="isSuperAdminOrIOHAdmin()">
              <img
                class="w-16"
                *ngIf="
                  !selectedFilterCompanyIds || !selectedFilterCompanyIds.length
                "
                (click)="companyDropdown.show()"
                src="assets/images/filter-outline.svg"
              />
              <img
                class="w-18"
                *ngIf="
                  selectedFilterCompanyIds && selectedFilterCompanyIds.length
                "
                (click)="companyDropdown.show()"
                src="assets/images/filter-filled.svg"
              />
              <p-multiSelect
                #companyDropdown
                (onPanelShow)="sortSelectedCompanyValues()"
                (onChange)="onSelectCompanyFilter()"
                [(ngModel)]="selectedFilterCompanyIds"
                [options]="companyOptions"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                styleClass="typeMulitselect-dd"
                [resetFilterOnHide]="true"
              >
                <ng-template pTemplate="header">
                  <span
                    class="cursor-pointer clear-icon underline"
                    (click)="
                      clearSelectedCompanyValues(selectedFilterCompanyIds)
                    "
                  >
                    <img
                      src="assets/images/filter-icn.svg"
                      alt="exclamation.svg"
                    />
                  </span>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
        </th>
        <th id="question">
          <div class="flex align-items-center gap-2">
            <span>Question</span>
            <div class="cursor-pointer" (click)="toggleQuestionSort()">
              <i class="pi" [ngClass]="getQuestionSortIcon()"></i>
            </div>
          </div>
        </th>
        <th class="text-center" id="visitType" [width]="'120px'">Visit Type</th>
        <th class="text-center" id="agencies" [width]="'150px'">
          <div class="flex align-items-center gap-2">
            <span>Agencies</span>
            <div class="filterClass">
              <img
                class="w-16"
                *ngIf="
                  !selectedFilterAgencyIds || !selectedFilterAgencyIds.length
                "
                (click)="dropdown.show()"
                src="assets/images/filter-outline.svg"
              />
              <img
                class="w-18"
                *ngIf="
                  selectedFilterAgencyIds &&
                  selectedFilterAgencyIds.length &&
                  selectedFilterAgencyIds.length > 0
                "
                (click)="dropdown.show()"
                src="assets/images/filter-filled.svg"
              />
              <p-multiSelect
                #dropdown
                (onPanelShow)="sortSelectedValues()"
                (onChange)="onSelectAgencyOrRole()"
                [(ngModel)]="selectedFilterAgencyIds"
                [options]="agenciesFilter"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                styleClass="typeMulitselect-dd"
                [resetFilterOnHide]="true"
              >
                <ng-template pTemplate="header">
                  <span
                    class="cursor-pointer clear-icon underline"
                    (click)="clearSelectedValues(selectedFilterAgencyIds)"
                  >
                    <img
                      src="assets/images/filter-icn.svg"
                      alt="exclamation.svg"
                    />
                  </span>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
        </th>
        <th class="text-center" id="formList" [width]="'70px'">Forms</th>
        <th class="text-center" id="formList" [width]="'50px'">Actions</th>
      </tr>
    </ng-template>
    <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
      <tr
        [pSelectableRow]="rowData"
        class="p-selectable-row"
        (click)="onRowClick(rowData)"
      >
        <td class="wrap-text">
          {{ rowData.questionId }}
        </td>
        <td class="wrap-text">
          {{ rowData.companyName }}
        </td>
        <td class="wrap-text">
          {{ rowData.question.value | questionText }}
        </td>
        <td class="text-center">
          {{ rowData.visitTypes }}
        </td>
        <td class="text-center" class="wrap-text">
          <span
            [pTooltip]="rowData.agenciesTooltip"
            tooltipPosition="left"
            [escape]="false"
            [tooltipDisabled]="!rowData.agencies?.length"
            [tooltipStyleClass]="'form-list-tooltip'"
          >
            {{ getAgencyNames(rowData.agencies) }}
          </span>
        </td>
        <td class="text-center">
          <span
            [pTooltip]="rowData.formListTooltip"
            tooltipPosition="left"
            [escape]="false"
            [tooltipDisabled]="!rowData.formList?.length"
            [tooltipStyleClass]="'form-list-tooltip'"
          >
            {{ rowData.formList?.length || 0 }}
          </span>
        </td>
        <td class="text-center">
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            (click)="onDeleteClick($event, rowData)"
            class="delete-btn p-button-rounded p-button-text p-button-danger"
            [loading]="rowData.isDeleting"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center">
          <span>
            <em class="pi pi-exclamation-circle mr-2"></em>
            No Questions found
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div>
    <p-paginator
      #paginator
      (onPageChange)="paginate($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [rows]="noOfRecordsPerRow"
      [totalRecords]="totalFormData"
      styleClass="gc-paginator"
    ></p-paginator>
  </div>
</div>

<p-sidebar
  [(visible)]="sideFormVisible"
  position="right"
  [showCloseIcon]="false"
  (onHide)="onSlideBarClose()"
>
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 class="gc-form-heading">
        {{ isEditMode ? "Update Question" : "Add Question" }}
      </h2>
      <span (click)="onSlideBarClose()" class="cursor-pointer">
        <em class="pi pi-times"></em>
      </span>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="popup-wrapper">
      <div class="form-container">
        <div class="gc-form-section">
          <form [formGroup]="formDataForm">
            <div class="sidebar-form">
            <!-- Question ID -->
            <div class="grid p-fluid mb-2" *ngIf="isEditMode">
              <div class="col-6">
                <label><b>Question ID: </b></label>
                <span class="text-600">{{ selectedRowData?.questionId }}</span>
              </div>
              <div class="col-6">
                <label><b>Version: </b></label>
                <span class="text-600">{{ selectedRowData?.version }}</span>
              </div>
            </div>
            <!-- Company Dropdown -->
            <div class="grid p-fluid" *ngIf="isSuperAdminOrIOHAdmin()">
              <div class="col-12">
                <label>Company<span class="red">*</span></label>
                <div>
                  <div class="assing-agncy">
                    <div class="assing-agncy-img">
                      <img
                        *ngIf="
                          getCompanySelectedIcon(formDataForm.value?.companyId)
                        "
                        [src]="
                          getCompanySelectedIcon(formDataForm.value?.companyId)
                        "
                        alt="company-img"
                      />
                    </div>
                    <div class="assing-agncy-filed">
                      <p-autoComplete
                        (completeMethod)="filterCompanies($event)"
                        (onSelect)="onSelectCompany($event)"
                        [forceSelection]="true"
                        [minLength]="1"
                        [showEmptyMessage]="true"
                        [suggestions]="filteredCompanyOptions"
                        field="label"
                        formControlName="companyId"
                        placeholder="Company"
                      ></p-autoComplete>
                      <img
                        *ngIf="showRemoveCompany()"
                        alt="search.svg"
                        src="../../../assets/images/search.svg"
                      />
                      <img
                        (click)="removeCompany()"
                        *ngIf="showRemoveCompany()"
                        alt="Checkbox%20base.svg"
                        src="../../../assets/images/Checkbox%20base.svg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Agencies Dropdown -->
            <div class="grid p-fluid mt-1">
              <div class="col-12">
                <label>Agencies<span class="red">*</span></label>
                <div class="p-multiselect-wrapper">
                  <ng-container *ngIf="!loadingAgencies; else agenciesLoading">
                    <p-multiSelect
                      [options]="agencies"
                      formControlName="agencies"
                      placeholder="Select Agencies"
                      [filter]="true"
                      optionLabel="label"
                      optionValue="value"
                      [showToggleAll]="true"
                      [disabled]="
                        (!formDataForm.get('companyId')?.value &&
                        isSuperAdminOrIOHAdmin())
                      "
                      pTooltip="Please select a company first"
                      tooltipPosition="top"
                      [tooltipDisabled]="
                        !isSuperAdminOrIOHAdmin() ||
                        !!formDataForm.get('companyId')?.value
                      "
                    ></p-multiSelect>
                  </ng-container>
                  <ng-template #agenciesLoading>
                    <p-multiSelect
                      [options]="agencies"
                      formControlName="agencies"
                      placeholder="Loading agencies..."
                      [filter]="true"
                      optionLabel="label"
                      optionValue="value"
                      [showToggleAll]="true"
                      [disabled]="true"
                    ></p-multiSelect>
                  </ng-template>
                  <i
                    *ngIf="loadingAgencies"
                    class="pi pi-spinner pi-spin loading-icon"
                  ></i>
                </div>
              </div>
            </div>

            <!-- Visit Types Dropdown -->
            <div class="grid p-fluid mt-1">
              <div class="col-12">
                <label>Visit Type<span class="red">*</span></label>
                <p-dropdown
                  [options]="visitTypeOptions"
                  formControlName="visitTypes"
                  placeholder="Select Visit Type"
                >
                </p-dropdown>
              </div>
            </div>

            <!-- Question Options -->
            <div class="grid p-fluid mt-1">
              <div class="col-12">
                <label>Select Question</label>
                <p-dropdown
                  [options]="questionOptions"
                  formControlName="questionOption"
                  placeholder="Select Question"
                  (onChange)="onQuestionOptionChange($event)"
                ></p-dropdown>
              </div>
            </div>

            <!-- Variant Options -->
            <div
              class="grid p-fluid mt-1"
              *ngIf="this.questionSelectedOption === subjectiveDefaultValue"
            >
              <div class="col-12">
                <label>Select Variant</label>
                <p-dropdown
                  [options]="subjectiveOptions"
                  formControlName="subjectiveOption"
                  placeholder="Select Question"
                  (onChange)="onSubjectiveChange()"
                ></p-dropdown>
              </div>
            </div>

            <!-- Question Textarea -->
            <div class="grid p-fluid mt-1">
              <div class="col-12">
                <textarea
                  class="p-inputtextarea"
                  pInputText
                  pInputTextarea
                  formControlName="question"
                  rows="5"
                  placeholder="Enter question"
                  [ngModel]="maskedQuestion"
                  (ngModelChange)="onQuestionChange($event)"
                >
                </textarea>
              </div>
            </div>

            <!-- Form Data -->
            <div class="grid p-fluid mt-1" formArrayName="formList">
              <div class="col-12">
                <div class="flex justify-content-between align-items-center">
                  <label>Form Data<span class="red">*</span></label>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-plus"
                    (click)="addFormListItem()"
                    class="p-button-rounded p-button-text p-button-info"
                  ></button>
                </div>

                <div
                  *ngFor="let form of formList.controls; let i = index"
                  [formGroupName]="i"
                  class="mt-2 form-data-item"
                >
                  <div class="flex align-items-start gap-2">
                    <div class="flex-grow-1">
                      <div class="mb-2">
                        <input
                          pInputText
                          formControlName="title"
                          placeholder="Enter title"
                          class="pInputTextExp pl-3 w-full"
                        />
                      </div>
                      <div>
                        <textarea
                          class="p-inputtextarea"
                          pInputText
                          pInputTextarea
                          formControlName="body"
                          rows="5"
                          placeholder="Enter body"
                        >
                        </textarea>
                      </div>
                    </div>
                    <button
                      pButton
                      type="button"
                      icon="pi pi-trash"
                      (click)="removeFormListItem(i)"
                      class="p-button-rounded p-button-text p-button-danger"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="gc-slide-footer flex justify-content-end gap-4">
      <button
        pButton
        label="Cancel"
        class="btn-cancel"
        [disabled]="isSubmitting"
        (click)="onSlideBarClose()"
      ></button>
      <button
        pButton
        [label]="isEditMode ? 'Update' : 'Add'"
        [disabled]="
          !formDataForm.valid ||
          isSubmitting ||
          (isEditMode && !formDataForm.dirty)
        "
        [loading]="isSubmitting"
        (click)="onSubmit()"
      ></button>
    </div>
  </ng-template>
</p-sidebar>
